import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function PdfReader({ url, pageNumber }) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumberView, setPageNumber] = useState(pageNumber);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    if (pageNumberView < numPages) {
      setPageNumber(pageNumberView);
    }
  }
  function changePage(offset) {
    console.log(Number(pageNumberView) + offset);
    setPageNumber((pageNumberView) => Number(pageNumberView) + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }
  return (
    <div className="pdfContainer">
      {/* <Document file="somefile.pdf" onLoadSuccess={onDocumentLoadSuccess}>
        <Page pageNumber={pageNumber} />
      </Document>
      <p>
        Page {pageNumber} of {numPages}
      </p> */}
      <Document file={url} onLoadSuccess={onDocumentLoadSuccess}>
        <Page pageNumber={Number(pageNumberView)} />
        {/* {Array.from(new Array(numPages), (el, index) => (
          <Page key={`page_${index + 1}`} pageNumber={index + 1} />
        ))} */}
      </Document>
      <p>
        Page {pageNumberView} of {numPages}
      </p>
      <button
        type="button"
        disabled={pageNumberView <= 1}
        onClick={previousPage}
      >
        Previous
      </button>
      <button
        type="button"
        disabled={pageNumberView >= numPages}
        onClick={nextPage}
      >
        Next
      </button>
    </div>
  );
}
export { PdfReader };
